import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { motion, AnimatePresence } from "framer-motion";
import { useInView } from "react-intersection-observer";
import CountUp from "react-countup";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Services() {
    // Auto change slide every 3 seconds
    const [current, setCurrent] = useState(0);
    const [index, setIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [animate, setAnimate] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [formType, setFormType] = useState(""); // stores which button opened the form

    const [loading, setLoading] = useState(false);
    const slides = [
        { text: "Review, Execute and Convert ABM Campaigns to Sales Leads" },
        { text: "Maximize ROI with Cost-Effective B2B Marketing Solutions" },
        { text: "Intent-Focused, Data-Driven Demand Generation for B2B Success" },
    ];

    const handleContactChange = (e) => {
        const { name, value } = e.target;
        setContactForm((prev) => ({ ...prev, [name]: value }));
    };
    const openModal = () => {
        setShowModal(true);
        setTimeout(() => setAnimate(true), 10); // trigger fade-in animation
    };
    // 🔹 Close modal
    const closeModal = () => {
        setAnimate(false);
        setTimeout(() => setShowModal(false), 300);
    };
    const [contactForm, setContactForm] = useState({
        fullname: "",
        company: "",
        website: "",
        email: "",
        phone: "",
        message: "",
        formType: "",
    });
    const isBusinessEmail = (email) => {
        const freeDomains = [
            "gmail.com",
            "yahoo.com",
            "hotmail.com",
            "outlook.com",
            "aol.com",
            "icloud.com",
            "mail.com",
            "live.com"
        ];
        const domain = email.split("@")[1]?.toLowerCase();
        if (!domain) return false;
        return !freeDomains.includes(domain);
    };

    const handleContactSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); // show loading message
        const { fullname, company, website, email, phone, message } = contactForm;
        // Basic validation
        if (!fullname || !email || !message || !company || !phone || !website) {
            alert("Please fill all required fields.");
            setLoading(false); // show loading message

            return;
        }
        if (!isBusinessEmail(email)) {
            alert("Please enter a business email, not Gmail/Yahoo/etc.");
            setLoading(false); // show loading message

            return;
        }


        try {
            try {
                const emailCheckResponse = await fetch(
                    `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
                );
                const emailCheckData = await emailCheckResponse.json();

                if (!emailCheckData.exists) {
                    setLoading(false);
                    alert("❌ The entered email does not exist. Please use a valid business email.");
                    return;
                }
            } catch (err) {
                setLoading(false);
                console.error("Email check failed:", err);
                alert("⚠️ Could not verify email existence. Try again later.");
                return;
            }
            const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    ...contactForm,
                    formType, // ✅ add formType manually here
                }),

            });

            if (response.ok) {
                setShowSuccessModal(true);  // ✅ This triggers modal to open
                setLoading(false); // show loading message
                closeModal();
                setContactForm({
                    fullname: "",
                    company: "",
                    website: "",
                    email: "",
                    phone: "",
                    message: "",
                });
            } else {
                alert("Error sending message.");
            }
        } catch (err) {
            console.error(err);
            alert("Error sending message.");
        }
    };
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.6,
                duration: 1,
                ease: "easeOut",
            },
        },
    };

    const itemVariants = (direction = "left") => {
        const distance = 80;
        const offset =
            direction === "left"
                ? { x: -distance }
                : direction === "right"
                    ? { x: distance }
                    : direction === "up"
                        ? { y: -distance }
                        : { y: distance };

        return {
            hidden: { opacity: 0, ...offset, scale: 0.95 },
            visible: {
                opacity: 1,
                x: 0,
                y: 0,
                scale: 1,
                transition: {
                    duration: 1.2,
                    ease: [0.25, 0.1, 0.25, 1], // smooth cubic-bezier
                },
            },
        };
    };

    useEffect(() => {
        const timer = setInterval(() => {
            setIndex((prev) => (prev + 1) % slides.length);
        }, 4500);
        return () => clearInterval(timer);
    }, [slides.length]);

    const currentSlide = slides[index] ?? { text: "" };

    const { ref, inView } = useInView({
        triggerOnce: true, // Counter triggers only once
        threshold: 0.3,    // 30% of div visible to start
    });


    const length = slides.length;

    const nextSlide = () => {
        setCurrent(current === length - 1 ? 0 : current + 1);
    };

    const prevSlide = () => {
        setCurrent(current === 0 ? length - 1 : current - 1);
    };
    const videos = [
        {
            src: "../images/tofuv.mp4",
            title: "TOFU",
        },
        {
            src: "../images/mofuv.mp4",
            title: "MOFU",
        },
        {
            src: "../images/bofuv.mp4",
            title: "BOFU",
        },
    ];

    // Brand logos slider
    const logos = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
    const brandSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 7,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        nextArrow: <div className="absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer text-black text-2xl">&#8250;</div>,
        prevArrow: <div className="absolute left-2 top-1/2 -translate-y-1/2 cursor-pointer text-black text-2xl">&#8249;</div>,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 4 } },
            { breakpoint: 768, settings: { slidesToShow: 3 } },
            { breakpoint: 480, settings: { slidesToShow: 2 } },
        ],
    };
    return (

        <div>

            <Header />

            <main>
                <marquee direction="left" style={{ backgroundColor: "orange", padding: "10px" }}>
                    Website under maintenance
                </marquee>
                <AnimatePresence>
                    {showSuccessModal && (
                        <motion.div
                            className="modal-overlay show"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                background: "rgba(0,0,0,0.5)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 9999,
                            }}
                        >
                            <motion.div
                                className="modal show"
                                initial={{ scale: 0.8, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                exit={{ scale: 0.8, opacity: 0 }}
                                transition={{ duration: 0.3 }}
                                style={{
                                    background: "#fff",
                                    padding: "30px",
                                    borderRadius: "10px",
                                    width: "400px",
                                    textAlign: "center",
                                    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                                }}
                            >
                                <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                                    Message Sent!
                                </h2>
                                <p>Thank you for contacting us. We will get back to you shortly.</p>
                                <button className="vc rg lk gh ml il hi gi _l"
                                    onClick={() => setShowSuccessModal(false)}

                                >
                                    Close
                                </button>
                            </motion.div>
                        </motion.div>
                    )}
                </AnimatePresence>
                {/* 🔹 Modal */}
                {showModal && (
                    <div
                        className={`modal-overlay ${animate ? "show" : ""}`}
                        onClick={(e) => {
                            if (e.target.classList.contains("modal-overlay")) {
                                closeModal();
                            }
                        }}
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: "rgba(0, 0, 0, 0.5)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 1000,
                            opacity: animate ? 1 : 0,
                            transition: "opacity 0.3s ease",
                        }}
                    >
                        <motion.div
                            className="modal-box"
                            initial={{ scale: 0.8, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.8, opacity: 0 }}
                            transition={{ duration: 0.3 }}
                            style={{
                                position: "relative",
                                background: "#fff",
                                padding: "30px",
                                borderRadius: "10px",
                                textAlign: "center",
                                boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                            }}
                        >
                            {/* Close button */}
                            <button
                                onClick={closeModal}
                                style={{
                                    position: "absolute",
                                    top: "10px",
                                    right: "15px",
                                    background: "transparent",
                                    border: "none",
                                    fontSize: "22px",
                                    cursor: "pointer",
                                    color: "#333",
                                }}
                            >
                                ×
                            </button>

                            <h2 className="fk tj kk wm bb">
                                Contact Now
                            </h2>
                            <form onSubmit={(e) => handleContactSubmit(e)}>
                                <div className="tc sf yo ap zf xi1">
                                    <div className="vd to/2">
                                        <input
                                            type="text"
                                            name="fullname"
                                            id="fullname"
                                            placeholder="Full name"
                                            value={contactForm.fullname}
                                            onChange={handleContactChange}
                                            className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
                                        />
                                    </div>

                                    <div className="vd to/2">
                                        <input
                                            type="text"
                                            name="company"
                                            id="company"
                                            placeholder="Company name"
                                            value={contactForm.company}
                                            onChange={handleContactChange}
                                            className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
                                        />
                                    </div>
                                </div>

                                <div className="tc sf yo ap zf xi1">
                                    <div className="vd to/2">
                                        <input
                                            type="text"
                                            name="website"
                                            id="website"
                                            placeholder="Website"
                                            value={contactForm.website}
                                            onChange={handleContactChange}
                                            className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
                                        />
                                    </div>

                                    <div className="vd to/2">
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Email address"
                                            id="email"
                                            value={contactForm.email}
                                            onChange={handleContactChange}
                                            className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
                                        />
                                    </div>
                                </div>

                                <div className="tc sf yo ap zf xi1">
                                    <div className="vd to/2">
                                        <input
                                            type="text"
                                            name="phone"
                                            id="phone"
                                            placeholder="Phone number"
                                            value={contactForm.phone}
                                            onChange={(e) => {
                                                // Allow only digits
                                                const value = e.target.value.replace(/\D/g, "");
                                                setContactForm((prev) => ({ ...prev, phone: value }));
                                            }}
                                            maxLength={10} // optional: limit to 10 digits
                                            className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
                                        />

                                    </div>
                                </div>

                                <div className="fb">
                                    <textarea
                                        placeholder="Message"
                                        rows="3"
                                        name="message"
                                        id="message"
                                        value={contactForm.message}
                                        onChange={handleContactChange}
                                        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
                                    ></textarea>
                                </div>

                                <div className="tc xf">
                                    <button
                                        type="submit"
                                        className="vc rg lk gh ml il hi gi _l"
                                        disabled={loading}
                                    >
                                        {loading ? "Please wait..." : " Send Message"}
                                    </button>

                                </div>
                            </form>
                        </motion.div>
                    </div>
                )}
                <section className="hero-section herovv1">
                    {/*<video className="hero-video" 
       preload="metadata" loading="lazy" src="/images/bg1set.mp4" autoPlay muted loop playsInline />*/}

                    <div className="hero-overlay" />

                    <div className="hero-content">
                        <div className="hero-inner">
                            <motion.section
                                initial={{ opacity: 0, y: 100 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
                                transition={{
                                    duration: 1.8,
                                    ease: "easeOut",
                                    type: "spring",
                                    stiffness: 40,
                                    damping: 20,
                                }}
                            >
                                <h1 className="fk vj zp or wcol wm wb">

                                    Global B2B Demand Generation Agency
                                    <br />
                                </h1>
                            </motion.section>
                            <motion.section
                                initial={{ opacity: 0, y: 100 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
                                transition={{
                                    duration: 1.8,
                                    ease: "easeOut",
                                    type: "spring",
                                    stiffness: 40,
                                    damping: 20,
                                }}
                            >
                                <h4 className="subhdcss"> Your Strategic Partner in Intelligent, Scalable Marketing Solutions</h4><br />
                                <button
                                    type="button"
                                    className="ek jk lk gh gi hi rg ml il vc _d _l"
                                    onClick={() => {
                                        setFormType("Home Page");
                                        openModal(true); // or scroll to form if no modal
                                    }}
                                >
                                    Contact Today
                                </button>

                            </motion.section>



                        </div>
                    </div>
                </section>
                <section className="section" id="services" style={{ background: "#F9FAFB" }}>
                    {/* Section Title */}
                    <motion.section
                        initial={{ opacity: 0, y: 100 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: false, amount: 0.3 }}
                        transition={{
                            duration: 1.2,
                            ease: "easeOut"
                        }}
                    >
                        <div className="bb ze rj ki xn vq">
                            <h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
                                Our Services
                            </h2>
                        </div>

                        <div className="funnel-grid">

                            <div className="funnel-card">
                                <div className="funnel-icon">&#127919;</div>
                                <span className="tag">Top of Funnel</span>
                                <h3>TOFU</h3>
                                <ul className="funnel-services">
                                    <a href="Tofuemail"><li>EMAIL MARKETING</li></a>
                                    <a href="Tofuinent"><li>INTENT DATA SERVICES</li></a>
                                    <a href="Contentsyndi"><li>CONTENT SYNDICATION</li></a>
                                    <a href="Displaymarketing"><li>DISPLAY MARKETING</li></a>
                                </ul>
                            </div>
                            <div className="funnel-card">
                                <div className="funnel-icon">&#128293;</div>
                                <span className="tag">Middle of Funnel</span>
                                <h3>MOFU</h3>
                                <ul className="funnel-services">
                                    <a href="Moumarketingqul"><li>MQL (MARKETING QUALIFIED LEAD)</li></a>
                                    <a href="Mouhql"><li>HQL (HIGHLY QUALIFIED LEAD)</li></a>
                                    <a href="Moubant"><li>BANT (BUDGET, AUTHORITY, NEED, TIME)</li></a>
                                    <a href="Mouwebinar"><li>WEBINAR</li></a>
                                </ul>
                            </div>
                            <div className="funnel-card">
                                <div className="funnel-icon">&#128640;</div>
                                <span className="tag">Bottom of Funnel</span>
                                <h3>BOFU </h3>
                                <ul className="funnel-services">
                                    <a href="Bofuappoin"><li>APPOINTMENT GENERATION</li></a>
                                    <a href="Bofusql"><li>SQL (SALES QUALIFIED LEADS)</li></a>
                                </ul>
                            </div>
                        </div>

                    </motion.section>
                </section>


                <br />
            </main>
            <Footer />
        </div>
    );
}

export default Services;
